// src/Routes.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
//import Paineis from './pages/Paineis';
import Sensores from './pages/Sensores';
import Molduras from './pages/Molduras';
import Acessorios from './pages/Acessorios';
import Downloads from './pages/Downloads';
import Instaladores from './pages/Instaladores';
import About from './About';
import NaoEncontrado from './pages/NaoEncontrado'
import Carrinho from './pages/Carrinho';
import InformacoesProduto from './pages/InformacoesProduto';
import PoliticaDevolucao from './pages/PoliticaDevolucao';
import FinalizarCompra from './pages/FinalizarCompra';
import SucessoCompra from './pages/SucessoCompra';
import MeusPedidos from './pages/MeusPedidos';

function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/paineis" element={<Home />} />
        <Route path="/sensores" element={<Sensores />} />
        <Route path="/molduras" element={<Molduras />} />
        <Route path="/acessorios" element={<Acessorios />} />
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/instaladores" element={<Instaladores />} />
        <Route path="/sobre" element={<About />} />
        <Route path="/carrinho" element={<Carrinho />} />
        <Route path="/finalizarCompra" element={<FinalizarCompra />} />
        <Route path="/produto/:id" element={<InformacoesProduto />} />
        <Route path="/politica-de-devolucao" element={<PoliticaDevolucao />} />
        <Route path="/sucessoCompra/:pagamento" element={<SucessoCompra />} />
        <Route path="/sucessoCompra" element={<SucessoCompra />} />
        <Route path="/meusPedidos" element={<MeusPedidos />} />
        <Route path="*" element={<NaoEncontrado />} /> {/* Rota para tratar 404 */}
      </Routes>
    </Router>
  );
}

export default AppRoutes;
